export default __webpack_public_path__ + "static/media/doctor-intro.d910265f.svg";